import React from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  TextField,
  InputAdornment,
  SvgIcon,
} from '@material-ui/core';
import { Search as SearchIcon, RefreshCw as RefreshIcon } from 'react-feather';

// eslint-disable-next-line react/prop-types
const JobsToolBar = ({ handleSearchStr, onRefresh, refreshing }) => (
  <Box>
    <Box sx={{ mt: 3 }}>
      <Card>
        <CardContent>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Box sx={{ maxWidth: 500, flexGrow: 1 }}>
              <TextField
                fullWidth
                onChange={(e) => handleSearchStr(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SvgIcon fontSize="small" color="action">
                        <SearchIcon />
                      </SvgIcon>
                    </InputAdornment>
                  ),
                }}
                placeholder="Search job"
                variant="outlined"
              />
            </Box>
            <Button
              color="primary"
              variant="outlined"
              onClick={onRefresh}
              disabled={refreshing}
              startIcon={
                <SvgIcon fontSize="small">
                  <RefreshIcon />
                </SvgIcon>
              }
            >
              {refreshing ? 'Refreshing…' : 'Refresh'}
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Box>
  </Box>
);

export default JobsToolBar;
